import { render, staticRenderFns } from "./my-btn.vue?vue&type=template&id=453cfbe8&scoped=true&"
import script from "./my-btn.vue?vue&type=script&lang=js&"
export * from "./my-btn.vue?vue&type=script&lang=js&"
import style0 from "./my-btn.vue?vue&type=style&index=0&id=453cfbe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cfbe8",
  null
  
)

export default component.exports